import { nuxtAuthRepository } from '~~/adapters/repositories/nuxt/nuxtAuthRepository';

export interface OtpValidationResult {
	success: boolean;
	error?: string;
}

export interface PhoneRegistrationData {
	phoneNumber: string;
	otp: string;
	email?: string;
	name?: string;
}

export function useAuthService() {
	const logger = useLogger('AuthService');
	async function sendOtpCode(
		phoneNumber: string
	): Promise<OtpValidationResult> {
		try {
			const [_, error] = await nuxtAuthRepository.phone({ phoneNumber });

			if (error) {
				return {
					success: false,
					error: error.message || 'Erro ao enviar código OTP'
				};
			}

			return { success: true };
		} catch (error) {
			logger.error('Erro inesperado ao enviar código OTP', {
				phoneNumber,
				error
			});
			return {
				success: false,
				error: 'Erro inesperado ao enviar código OTP'
			};
		}
	}

	async function validatePhoneOtp(
		data: PhoneRegistrationData
	): Promise<OtpValidationResult> {
		try {
			const [_, error] = await nuxtAuthRepository.getCreatePhoneUser(data);

			if (error) {
				return {
					success: false,
					error: error.message || 'Erro ao validar código OTP'
				};
			}

			return { success: true };
		} catch (error) {
			logger.error('Erro inesperado ao validar código OTP', {
				phoneNumber: data.phoneNumber,
				error
			});
			return {
				success: false,
				error: 'Erro inesperado ao validar código OTP'
			};
		}
	}

	async function validateSocialOtp(otp: string): Promise<OtpValidationResult> {
		try {
			const [_, error] = await nuxtAuthRepository.verifySocialRegistration({
				otp
			});

			if (error) {
				return {
					success: false,
					error: error.message || 'Erro ao validar código OTP'
				};
			}

			return { success: true };
		} catch (error) {
			logger.error('Erro inesperado ao validar código OTP social', {
				error
			});
			return {
				success: false,
				error: 'Erro inesperado ao validar código OTP'
			};
		}
	}

	async function completePhoneRegistration(
		name: string,
		email?: string
	): Promise<OtpValidationResult> {
		try {
			const [_, error] = await nuxtAuthRepository.completePhoneRegistration({
				name,
				...(email ? { email } : {})
			});

			if (error) {
				return {
					success: false,
					error: error.message || 'Erro ao completar cadastro'
				};
			}

			return { success: true };
		} catch (error) {
			logger.error('Erro inesperado ao completar cadastro', {
				name,
				email,
				error
			});
			return {
				success: false,
				error: 'Erro inesperado ao completar cadastro'
			};
		}
	}

	async function completeSocialRegistration(
		phoneNumber: string
	): Promise<OtpValidationResult> {
		try {
			const [_, error] = await nuxtAuthRepository.completeSocialRegistration({
				phoneNumber
			});

			if (error) {
				return {
					success: false,
					error: error.message || 'Erro ao completar cadastro social'
				};
			}

			return { success: true };
		} catch (error) {
			logger.error('Erro inesperado ao completar cadastro social', {
				phoneNumber,
				error
			});
			return {
				success: false,
				error: 'Erro inesperado ao completar cadastro social'
			};
		}
	}

	return {
		sendOtpCode,
		validatePhoneOtp,
		validateSocialOtp,
		completePhoneRegistration,
		completeSocialRegistration
	};
}
